import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { MessageCircleQuestionMark } from "lucide-react";
const faqs = [{
  question: "How long does a full detail take?",
  answer: "A full interior and exterior detail typically requires 2 to 3 hours of work. This timeframe allows our detailers to clean every part of your vehicle."
}, {
  question: "What are the benefits of Ceramic Coating?",
  answer: "Ceramic coating provides a liquid polymer layer that shields your paint from UV rays, chemical stains, and light scratches. It creates a hydrophobic surface that keeps your car clean while giving a glass-like gloss for 3 to 4 months."
}, {
  question: "Is your interior process safe for high-end leather?",
  answer: "Absolutely. We use pH-balanced, professional-grade cleaners and premium conditioners specifically made for luxury leather."
}, {
  question: "Do you offer mobile detailing services?",
  answer: "To maintain our obsessive standards for quality, we operate exclusively from our climate-controlled studio. This ensures a dust-free environment for coatings and optimal lighting to identify and correct paint imperfections that mobile setups might miss."
}, {
  question: "How often should I schedule a professional detail?",
  answer: "For vehicles driven daily, we recommend a detail every 4 to 6 months. This frequency ensures that protective layers are maintained and contaminants are removed before they can cause permanent damage to your vehicle."
}];
export default function ExpertKnowledgeBase() {
  return <section data-section-id="30577" id="detailing-insights" className="bg-background py-20 dark text-foreground">
      <div className="mx-auto max-w-3xl px-6">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-default tracking-tight text-primary sm:text-4xl">
            Detailing Insights
          </h2>
          <p className="mt-4 text-lg font-default text-muted-foreground">
            Common questions about our premium automotive restoration services.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-primary/20 last:border-0" data-index={i}>
              <AccordionTrigger className="text-left text-xl font-default text-primary hover:no-underline hover:text-primary/80 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base font-default leading-[1.6] text-foreground/90 pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 flex justify-center">
          <Link to="#">
            
          </Link>
        </div>
      </div>
    </section>;
}